import { frameColumnsForSearchClaims } from '../../../utils/common';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MasterPermissions from '../../../api/MasterPermissions';
import { Col, Row, Nav } from 'react-bootstrap';
//import { ToastContainer } from 'react-toastify';
import ClaimsTable from './ClaimsTable';
import { Link } from 'react-router-dom';
import { ClaimsSVG } from '../../../../Member/img/GlobalSVG';
import {
  CustomPagination,
  CustomPaginationItemsDisplay,
} from '../../../components/common/CustomPagination';
import { DownloadDropdown } from '../../common/downloadFiles';
import Feature from '../../../../../src/services/feature';
import {
  ClaimsPDFEmailBody,
  ClaimsCSVEmailBody,
} from '../../../configuration/EmailData';
import { setSearchParams } from 'src/redux/admin/claimsSlice';
import Skeleton from 'src/Admin/components/common/skeleton';
import useDate from '../../../utils/useDate';

//const claim_resource = '/admin/claim-details?CID=';
const displayPaginationMininumCount = 10;

const EobValue = () => {
  //Disabling Link for EoB
  return (
    <p className="email-icon">
      <Link onClick={(e) => e.preventDefault()} to="/member/claims">
        <span>
          <ClaimsSVG.ViewJobSVG />
        </span>
        View EOB
      </Link>
    </p>
  );
};

const EobEmpty = (claimOID, preserveData) => {
  //const claim_resource_url = `${claim_resource}${claimOID}&source=claims`;
  return (
    <p className="email-icon">
      <Link
        to="admin/search-claim-details"
        state={preserveData}
        search={`?CID=${claimOID}&source=claims`}
      >
        {/*<span>
          <ClaimsSVG.ClaimEmailSVG />
        </span> */}
        View Details
      </Link>
    </p>
  );
};

const ClaimListGrid = ({
  dataFetching,
  isAPIFailed,
  filteredClaimsData,
  selectedUserFirstName,
  selectedUserEmail,
  preserveData,
  totalRecords,
  setTotalRecords,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
  pageSizeStore,
  pageNumber,
  sortByColumn,
}) => {
  const dispatch = useDispatch();
  const { formatDate } = useDate();
  const frameDataToDisplay = (claimsListData) => {
    /*const claimsList = sortHandler(
    sortByColumn[0].id,
    sortByColumn[0].desc,
    claimsListData,
    );*/

    const claimsList = claimsListData;
    console.log('claimsList====', claimsList);
    if (claimsList?.length > 0) {
      const recordsToDisplay = [];
      const iterationCount = claimsList.length;
      for (let iIndex = 0; iIndex < iterationCount; iIndex++) {
        const memberORDependentOID = Object.prototype.hasOwnProperty.call(
          claimsList[iIndex],
          'DependentOid',
        )
          ? claimsList[iIndex].DependentOid
          : claimsList[iIndex].MemberOid;
        const memberORDependentType = Object.prototype.hasOwnProperty.call(
          claimsList[iIndex],
          'DependentOid',
        )
          ? 'Dependent'
          : 'Employee';
        const claimsDetailsOidTypePreserveData = {
          OID: memberORDependentOID,
          memberType: memberORDependentType,
          preserveData: preserveData,
        };
        recordsToDisplay.push({
          ServiceDate: formatDate(claimsList[iIndex].ServiceDate),
          PatientName: claimsList[iIndex].PatientName,
          Product: claimsList[iIndex].Product,
          Claimnumber: (
            <Link
              to={`/admin/search-claim-details?CID=${claimsList[iIndex].OID}&source=claims`}
              state={claimsDetailsOidTypePreserveData}
              //to={`${claim_resource}${claimsList[ iIndex ].OID}&source=claims`}
            >
              <span className="link-color">
                {claimsList[iIndex].Claimnumber}
              </span>
            </Link>
          ),
          ClaimNumber: claimsList[iIndex].Claimnumber,
          ProviderName:
            claimsList[iIndex].ProviderName === claimsList[iIndex].FacilityName
              ? claimsList[iIndex].FacilityName
              : claimsList[iIndex].ProviderFirstName +
                ' ' +
                claimsList[iIndex].ProviderLastName,
          ClaimStatus: claimsList[iIndex].ClaimStatus,
          TotalCharge: claimsList[iIndex].TotalCharge,
          PatientResponsibility:
            claimsList[iIndex].DisplayPaymentInfo === 'true'
              ? claimsList[iIndex].PatientResponsibility
              : -1,
          TotalPaid: claimsList[iIndex].TotalPaid,
          Action: claimsList[iIndex].EOB
            ? EobValue()
            : EobEmpty(claimsList[iIndex].OID, preserveData),
        });
      }
      console.log(recordsToDisplay);
      setRecordsToDisplay(recordsToDisplay);
      setPageSize(pageSizeStore);
      setCurrentPage(pageNumber);
      //recordsFilterHandler(recordsToDisplay, pageSizeStore, pageNumber);
      setFilteredRecords(recordsToDisplay);
    } else {
      console.log('No Transactions Found');
      setRecordsToDisplay([]);
    }
  };
  //const {
  //searchParms: { pageSize: pageSizeStore, pageNumber, sortBy: sortByColumn },
  //claimsResult,
  //activeUserOID,
  //} = useSelector(({ claims }) => claims);
  useEffect(() => {
    if (filteredClaimsData?.length > 0) {
      frameDataToDisplay(filteredClaimsData);
    }
  }, [pageSizeStore, pageNumber]);
  //The below one is Master List
  const [recordsToDisplay, setRecordsToDisplay] = useState(null);
  //FilteredList
  const [filteredRecords, setFilteredRecords] = useState([]);
  //pagination specific states
  //const [pageSize, setPageSize] = useState(pageSizeStore);
  //const [currentPage, setCurrentPage] = useState(pageNumber);
  //const [totalRecords, setTotalRecords] = useState(0);

  const pageSizeHandler = (pageSizeInfo) => {
    setPageSize(pageSizeInfo.value);
    dispatch(setSearchParams({ pageSize: pageSizeInfo.value }));
    dispatch(setSearchParams({ pageNumber: 1 }));
    //recordsFilterHandler(recordsToDisplay, pageSizeInfo.value, currentPage);
    setFilteredRecords(recordsToDisplay);
  };

  //eslint-disable-next-line no-unused-vars
  let shareClaim = false;
  let downloadClaim = false;

  if (MasterPermissions.CheckPermission('Download Claims'))
    downloadClaim = true;

  if (MasterPermissions.CheckPermission('Share Claims')) shareClaim = true;

  /*const recordsFilterHandler = (masterDataList, pageSize, currentPage) => {
    const filteredData = [];
    masterDataList.forEach((eachItem, index) => {
      if (
        index >= pageSize * currentPage - pageSize &&
        index < pageSize * currentPage
      ) {
      filteredData.push(eachItem);
      }
    });
    //console.log("data received:",filteredData)
    //const formattedData= formatFilteredData( filteredData );
    setFilteredRecords(filteredData);
  };*/

  const formatFilteredData = (data) => {
    return data.map((item) => ({ ...item, ServiceDate: item.ServiceDate }));
  };

  /*const sortHandler = (sortColumn, isDesending, claimData) => {
    const sortedData = [...claimData];
    if (sortColumn === 'TotalCharge' || sortColumn === 'TotalPaid') {
      if (isDesending) {
        sortedData.sort((a, b) => b[sortColumn] - a[sortColumn]);
      } else {
        sortedData.sort((a, b) => a[sortColumn] - b[sortColumn]);
      }
    } else if (sortColumn === 'ServiceDate') {
      if (isDesending) {
        sortedData.sort(
          (a, b) => new Date(b.ServiceDate) - new Date(a.ServiceDate),
        );
      } else {
        sortedData.sort(
          (a, b) => new Date(a.ServiceDate) - new Date(b.ServiceDate),
        );
      }
    } else if (sortColumn === 'Claimnumber') {
      if (isDesending) {
        sortedData.sort((a, b) => {
          let aNumber, bNumber;
          if (Object.prototype.hasOwnProperty.call(a, 'ClaimNumber')) {
            aNumber = +a.ClaimNumber.split('-').join('');
            bNumber = +b.ClaimNumber.split('-').join('');
          } else {
            aNumber = +a.Claimnumber.split('-').join('');
            bNumber = +b.Claimnumber.split('-').join('');
          }
          if (aNumber > bNumber) {
            return -1;
          }
          if (aNumber < bNumber) {
            return 1;
          }
          return 0;
        });
      } else {
        sortedData.sort((a, b) => {
          let aNumber, bNumber;
          if (Object.prototype.hasOwnProperty.call(a, 'ClaimNumber')) {
            aNumber = +a.ClaimNumber.split('-').join('');
            bNumber = +b.ClaimNumber.split('-').join('');
          } else {
            aNumber = +a.Claimnumber.split('-').join('');
            bNumber = +b.Claimnumber.split('-').join('');
          }
          if (aNumber > bNumber) {
            return 1;
          }
          if (aNumber < bNumber) {
            return -1;
          }
          return 0;
        });
      }
    } else {
      if (isDesending) {
        sortedData.sort((a, b) => {
          const fa = a[sortColumn].toLowerCase(),
            fb = b[sortColumn].toLowerCase();

          if (fa > fb) {
            return -1;
          }
          if (fa < fb) {
            return 1;
          }
          return 0;
        });
      } else {
        sortedData.sort((a, b) => {
          const fa = a[sortColumn].toLowerCase(),
            fb = b[sortColumn].toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      }
    }
    return sortedData;
  };*/

  const serverSideSorting = (sortyByData) => {
    //setCurrentPage(1);
    dispatch(setSearchParams({ sortBy: [sortyByData[0]] }));
    //dispatch(setSearchParams({ pageNumber: 1 }));
  };

  /*const customSortingHandler = (sortColumn, isDesending, sortyByData) => {
    if (
      sortByColumn[0].id != sortColumn ||
      sortByColumn[0].desc != isDesending
    ) {
      const customSortData = sortHandler(
        sortColumn,
        isDesending,
        recordsToDisplay,
      );
      setRecordsToDisplay(customSortData);
      dispatch(setSearchParams({ sortBy: [sortyByData[0]] }));
      //recordsFilterHandler(customSortData, pageSize, currentPage);
      setFilteredRecords(customSortData);
    }
  };*/

  const tableHeader = [
    { header: 'SERVICE DATE', dataKey: 'ServiceDate' },
    { header: 'PATIENT NAME  ', dataKey: 'PatientName' },
    { header: 'CLAIM TYPE', dataKey: 'Product' },
    { header: 'CLAIM NUMBER', dataKey: 'ClaimNumber' },
    { header: 'PROVIDER', dataKey: 'ProviderName' },
    { header: 'STATUS', dataKey: 'ClaimStatus' },
    { header: 'AMOUNT', dataKey: 'TotalCharge' },
    { header: 'PATIENT RESPONSIBILITY', dataKey: 'PatientResponsibility' },
    { header: 'PLAN PAYS', dataKey: 'TotalPaid' },
  ];

  const showingRecordsMessage = () => {
    let message = '';
    message = `Showing ${currentPage * pageSize - pageSize + 1} - ${
      pageSize * currentPage < totalRecords
        ? pageSize * currentPage
        : totalRecords
    } of ${totalRecords} results`;
    return message;
  };

  const columnNames = useMemo(() => {
    return frameColumnsForSearchClaims();
  }, [filteredClaimsData]);

  const frameDataForCSV = (csvData) => {
    const csvDetailedInfo = [];
    if (csvData?.length > 0) {
      csvData.forEach((csvInfo) => {
        const { Claimnumber, Action, ...requiredCsvInfo } = csvInfo;
        requiredCsvInfo.TotalPaid =
          requiredCsvInfo.TotalPaid === -1 ? '---' : requiredCsvInfo.TotalPaid;
        csvDetailedInfo.push(requiredCsvInfo);
      });
      return csvDetailedInfo;
    }
  };

  useEffect(() => {
    if (filteredClaimsData?.length > 0) {
      frameDataToDisplay(filteredClaimsData);
      //setTotalRecords(filteredClaimsData.length);
    } else {
      if (!dataFetching) {
        frameDataToDisplay([]);
      }
      setFilteredRecords([]);
      setTotalRecords(0);
    }
  }, [filteredClaimsData]);

  console.log('recordsToDisplay', recordsToDisplay);
  console.log('shareClaim', shareClaim);
  console.log('downloadClaim', downloadClaim);

  return (
    <>
      {recordsToDisplay !== null ? (
        <>
          <Col sm={12}>
            <Row className="mb-4 align-items-center">
              <Col sm={12} className="d-none d-md-block">
                <div
                  style={{
                    display: 'flex',
                    float: 'right',
                    'align-items': 'baseline',
                  }}
                >
                  <Nav className="myaccount-style-item-text download-table">
                    {recordsToDisplay?.length > 0 && (
                      <div className="d-flex ml-2">
                        {downloadClaim && (
                          <DownloadDropdown
                            data={
                              recordsToDisplay?.length > 0
                                ? frameDataForCSV(recordsToDisplay)
                                : []
                            }
                            label="Download"
                            fileName="ClaimsSearchReport"
                            showCSV={true}
                            showPDF={true}
                            //openPDF={ true }
                            tableHeader={tableHeader}
                          />
                        )}

                        {shareClaim && (
                          <DownloadDropdown
                            data={
                              recordsToDisplay?.length > 0
                                ? frameDataForCSV(recordsToDisplay)
                                : []
                            }
                            label="Send"
                            fileName="ClaimsSearchReport"
                            showCSV={true}
                            showPDF={true}
                            tableHeader={tableHeader}
                            sendEmail={true}
                            emailPDFBody={ClaimsPDFEmailBody}
                            emailCSVBody={ClaimsCSVEmailBody}
                            userName={selectedUserFirstName}
                            userEmail={selectedUserEmail}
                            successMessage="Claims list has been sent to your registered Email ID"
                            errorMessage="Claims list has not been sent."
                            addressCC=""
                            addressBCC=""
                          />
                        )}
                      </div>
                    )}
                  </Nav>
                </div>
              </Col>
            </Row>
            <Row className="mb-4 align-items-center">
              <Col sm={6} className="pagination-display">
                {totalRecords > displayPaginationMininumCount ? (
                  <CustomPaginationItemsDisplay
                    pageSize={pageSize}
                    setPageSize={pageSizeHandler}
                    prefixMessage="Records per page"
                    suffixMessage={showingRecordsMessage()}
                  />
                ) : null}
              </Col>
              <Col sm={6} className="text-right mt-4 mt-md-0">
                <div className="claims-pagination float-right">
                  {totalRecords > displayPaginationMininumCount ? (
                    <CustomPagination
                      pageSize={pageSize}
                      currentPage={currentPage}
                      totalCount={totalRecords}
                      onPageChange={(page) => {
                        setCurrentPage(page);
                        dispatch(setSearchParams({ pageNumber: page }));
                        //recordsFilterHandler(recordsToDisplay, pageSize, page);
                        setFilteredRecords(recordsToDisplay);
                      }}
                    />
                  ) : null}
                </div>
              </Col>
            </Row>
          </Col>
          <Col sm={12}>
            <div className="claims-list-grid" id="pdfdiv">
              <ClaimsTable
                className="account-table"
                columns={columnNames}
                data={filteredRecords}
                keyField={columnNames}
                pageSizeCount={pageSize}
                preserveData={preserveData}
                dataFetching={dataFetching}
                //customSortingHandler={customSortingHandler}
                sortByColumn={sortByColumn[0]}
                recordsToDisplay={recordsToDisplay}
                serverSideSorting={serverSideSorting}
              />
            </div>
          </Col>
          <Col sm={12}>
            <Row className="mt-4 mb-4 align-items-center">
              {totalRecords > displayPaginationMininumCount && (
                <>
                  <Col sm={6}>
                    <CustomPaginationItemsDisplay
                      pageSize={pageSize}
                      setPageSize={pageSizeHandler}
                      prefixMessage="Records per page"
                    />
                  </Col>
                  <Col sm={6} className="text-right mt-4 mt-md-0">
                    <div className="claims-pagination float-right">
                      {totalRecords > displayPaginationMininumCount ? (
                        <CustomPagination
                          pageSize={pageSize}
                          currentPage={currentPage}
                          totalCount={totalRecords}
                          onPageChange={(page) => {
                            setCurrentPage(page);
                            dispatch(setSearchParams({ pageNumber: page }));
                            //recordsFilterHandler(recordsToDisplay, pageSize, page);
                            setFilteredRecords(recordsToDisplay);
                          }}
                        />
                      ) : null}
                    </div>
                  </Col>
                </>
              )}
              {/*<div className="toastify">
            <ToastContainer
              position="top-center"
              autoClose={ 5000 }
              hideProgressBar={ false }
              newestOnTop={ false }
              closeOnClick
              rtl={ false }
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div> */}
            </Row>
          </Col>
        </>
      ) : (
        <Col sm={12}>
          <Skeleton count={10} height={15} className="plan-details-skeleton" />
        </Col>
      )}
    </>
  );
};

export default ClaimListGrid;
